module.exports = __webpack_public_path__ + "static/media/30shine.38a2a504.svg";